import { Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Section } from '../../editor-container/editor-model';
import { RenderedSection, SectionEditorBridgeService } from '../../services/section-editor-bridge.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { CellEditorStoreService } from '../cell-editor-store.service';

@Directive({
  selector: '[ngxBaseSectionEditor]'
})
export abstract class BaseSectionEditorDirective implements OnInit, OnDestroy, OnChanges {
  // @Input() selectedSection:Section;
  @Input() selectedRenderedSection: RenderedSection;
  @Input() selectedSection: Section;

  cellIdsThumbs: any[] = [];
  cellIdsThumbs$: Subscription;
  selectedSection$: Subscription;

  protected destroy$: Subject<void> = new Subject<void>();


  constructor(
    protected sectionEditorBridge: SectionEditorBridgeService,
    protected previewEditStoreService: PreviewEditStoreService) { }


  ngOnInit(): void {
    // console.log(this.selectedSection);
    /* this.selectedSection$ = this.previewEditStoreService.selectedSection$.pipe(takeUntil(this.destroy$)).subscribe((selectedSection: Section) => {
      this.selectedSection = selectedSection;
      console.log(this.selectedSection);

    }) */
    this.cellIdsThumbs$ = this.sectionEditorBridge.getCellIdsThumbs().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.cellIdsThumbs = data;
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedSection"]) {
      console.log(this.selectedSection);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }



}
